import request from './index'

// 管理员登录
export function login(data) {
  return request({
    url: '/admin/login',
    method: 'post',
    data
  })
}

// 获取管理员信息
export function getProfile() {
  return request({
    url: '/admin/profile',
    method: 'get'
  })
}

// 修改密码
export function changePassword(data) {
  return request({
    url: '/admin/change-password',
    method: 'put',
    data
  })
}

// 获取仪表板统计数据
export function getDashboardStats() {
  return request({
    url: '/admin/dashboard/stats',
    method: 'get'
  })
}

// 获取商户排行统计
export function getMerchantRanking(params) {
  return request({
    url: '/admin/statistics/merchant-ranking',
    method: 'get',
    params
  })
}

// 获取详细报表
export function getDetailReport(params) {
  return request({
    url: '/admin/statistics/detail-report',
    method: 'get',
    params
  })
}

// 获取商户列表
export function getMerchants(params) {
  return request({
    url: '/admin/merchants',
    method: 'get',
    params
  })
}

// 创建商户
export function createMerchant(data) {
  return request({
    url: '/admin/merchants',
    method: 'post',
    data
  })
}

// 更新商户
export function updateMerchant(id, data) {
  return request({
    url: `/admin/merchants/${id}`,
    method: 'put',
    data
  })
}

// 重置商户密码
export function resetMerchantPassword(id, newPassword) {
  return request({
    url: `/admin/merchants/${id}/reset-password`,
    method: 'put',
    data: { newPassword }
  })
}

// 为商户分配券
export function allocateCoupons(merchantId, data) {
  return request({
    url: `/admin/merchants/${merchantId}/coupons`,
    method: 'post',
    data
  })
}

// 获取券种列表
export function getCouponTypes() {
  return request({
    url: '/admin/coupon-types',
    method: 'get'
  })
}

// 获取系统配置
export function getSystemConfigs() {
  return request({
    url: '/admin/system/configs',
    method: 'get'
  })
}

// 更新系统配置
export function updateSystemConfigs(data) {
  return request({
    url: '/admin/system/configs',
    method: 'put',
    data
  })
}

// 获取操作日志
export function getOperationLogs(params) {
  return request({
    url: '/admin/logs',
    method: 'get',
    params
  })
}

// 获取券记录（替代原来的额度、充值、核销记录）
export function getCoupons(params) {
  return request({
    url: '/admin/coupons',
    method: 'get',
    params
  })
}

